import { useNavigate } from "react-router-dom";
import IsNullOrEmpty from "../../../models/helpers/isNullOrEmpty.ts";
import { SearchResult } from "../../../models/search/searchResult";

const ResultsList = ({
    results,
    showSearchTypes,
    handleAddItem
}: {
    results: SearchResult[];
    showSearchTypes: boolean;
    handleAddItem?: any;
}) => {
    const navigate = useNavigate();
    return (
        <ul className={`list-group ${showSearchTypes ? 'list-group-bottom' : ''}`}>
            {results.map((result) => (
                <li className="list-group-item d-flex flex-row px-2" key={`${result.type}-${result.resultID}`}>
                    <p className="my-auto w-100" onClick={() => navigate(`/${result.type}s/${result.resultID}`)} >{result.name}{!IsNullOrEmpty(result.brand) && !result.name.includes(result.brand) && !result.brand.includes(result.name) && <small className="text-muted"> - {result.brand}</small>}</p>
                    {handleAddItem && <h1 className="my-auto"><i className="bi bi-plus my-auto" onClick={() => handleAddItem(result)} /></h1>}
                </li>
            ))}
        </ul>
    )
}

export default ResultsList;